import { render } from "./orderReview.vue?vue&type=template&id=bf2562de&scoped=true"
import script from "./orderReview.vue?vue&type=script&lang=js"
export * from "./orderReview.vue?vue&type=script&lang=js"

import "./orderReview.vue?vue&type=style&index=0&id=bf2562de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\28950\\source\\repos\\xtz\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf2562de"]])

export default __exports__